module.exports = __webpack_public_path__ + "img/town-portal.eb2d91fb.gif";